import styled, { keyframes } from "styled-components";
import hexToRgbA, { hexToRgba } from "../HexToRGBA";

// --- ANIMATION KEYFRAMES ---
export const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: ${props => hexToRgba(props.theme.mainBg,0.15)};
  backdrop-filter: blur(4px);
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

export const ModalContainer = styled.div`
    display: ${props => props.isOpen? 'flex': 'none'}; /* Hidden by default */
    position: fixed; /* Stay in place */
    padding-top: 50px; /* Location of the box */
    left: 0;
    top: 0;
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    color: ${props => props.theme.secondaryBg};
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */ /* Fallback color */
    background-color: ${props => hexToRgba(props.theme.secondaryBg, 0.4)};
    z-index: 4444;

`

export const ModalWrapper = styled.div`

background-color: transparent;
margin: auto;
padding: 2%;
align-items: center;
justify-content: center;
color: ${props => hexToRgbA(props.theme.secondaryBg)};
flex-direction: column;
min-width: 60%;
max-width: 100%;
z-index: 44444;
`

export const Close = styled.div`
    display: flex;
    color: ${props => hexToRgbA(props.theme.secondaryBg)};;
    margin-left: 100%;
    width: 40px;
    height: 40px;
    font-size: 1.2rem;
    background-color: ${props => hexToRgbA(props.theme.mainBg)};;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: none;
    margin-bottom: 2%;
  
  &:hover, &: focus{
    color: ${props => hexToRgbA(props.theme.secondaryColor)};;
    text-decoration: none;
    cursor: pointer;
    `


    export const ModalBox = styled.div`
    display: flex;
    flex-direction: column;
    align-self:center;
      max-width: 844px;
      width: 100%;
      border-radius: 16px;
      padding: 24px;
      border: 1px solid ${props => props.theme.secondaryColor};
      position: relative;
      box-shadow: 0 25px 50px -12px ${props => hexToRgba(props.theme.background,0.55)};
      animation: ${fadeIn} 0.2s ease-out;
      background-color: ${props => props.theme.mainBg};
    `;
    
    export const ModalCloseBtn = styled.button`
      position: absolute;
      top: 16px;
      right: 16px;
      color: ${props => props.theme.secondaryColor};
      background: transparent;
      border: none;
      cursor: pointer;
      font-size: 1rem;
      
      &:hover {
        color: ${props => props.theme.secondaryColor};
      }
    `;
    
    export const SegmentedControl = styled.div`
      display: flex;
      gap: 8px;
      background-color: ${props => props.theme.mainBg};
      padding: 6px;
      border-radius: 8px;
      border: 1px solid ${props => props.theme.secondaryBg};
      margin-bottom: 24px;
    `;
    
    export const SegmentBtn = styled.button`
      flex: 1;
      padding: 8px;
      border-radius: 4px;
      font-weight: 700;
      font-size: 0.75rem;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      border: none;
      cursor: pointer;
      transition: all 0.2s ease;
      background: ${props => props.active ? props.theme.mainBg : "transparent"};
      color: ${props => props.active ?  props.theme.secondaryBg : props.theme.secondaryColor};
    
      &:hover {
        color: ${props => props.theme.secondaryBg};
      }
    `;